export const styles = {
	arrows: {
		marginBottom: '16px',
		width: '100%',
		display: 'flex',
		alignItems: 'center'
	},
	backIcon: {
		transform: 'rotate(180deg)'
	},
	backButton: {
		marginRight: '16px',
		width: '100%',
		maxWidth: 200
	},
	forwardButton: {
		color: '#fff',
		width: '100%',
		maxWidth: 200
	},
	loadingIcon: {
		marginLeft: '16px'
	}
};
